import React from 'react'
import styled from 'styled-components'

const HambergarWrap = styled.div`
  display: flex;
  opacity: 1;
  margin: 0 20px;
  align-items: center;
  justify-content: center;
  /* pointer-events: none; */
  cursor: pointer;
  .hamburger {
    width: 18px;
    height: 14px;
    background: transparent;
    border: none;
    display: flex;
    cursor: pointer;
    flex-direction: column;
    transition: 0.2s all ease-in-out;
    justify-content: space-between;
    &:focus {
      outline: none;
    }
    span {
      width: 18px;
      height: 2px;
      border-radius: 2px;
      background-color: ${(props) => (props.color ? props.color : '#fff')};
      transition: 0.2s all ease-in-out;
      display: block;
      &:nth-child(2) {
        display: ${(props) => (props.status ? 'none' : 'block')};
      }
      &:nth-child(1) {
        transform: translateY(${(props) => (props.status ? '6px' : '0')})
          rotate(${(props) => (props.status ? '-45deg' : '0')});
      }
      &:nth-child(3) {
        transform: translateY(${(props) => (props.status ? '-5px' : '0')})
          rotate(${(props) => (props.status ? '45deg' : '0')});
      }
    }
  }
  @media (max-width: 768px) {
    opacity: 1;
    pointer-events: all;
  }
`

const Hamburger = (props) => {
  return (
    <HambergarWrap status={props.status} color={props.color}>
      <button className="hamburger" onClick={props.handleStatus}>
        <span />
        <span />
        <span />
      </button>
    </HambergarWrap>
  )
}

export default Hamburger
